import { of, tap } from "rxjs";
import { Injectable } from "@angular/core";

import { MembershipPayload, Membership, MembershipFilter } from "../../interfaces";

import { environment } from "src/environments/environment";
import { HttpService, HttpServiceBaseCRUD, GetPagedBody } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class MembershipsService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "memberships/";
  }

  add(body: MembershipPayload) {
    return this.post<Membership>({ APIName: "add", body, showAlert: true });
  }

  update(body: MembershipPayload) {
    return this.put<Membership>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<Membership>({ APIName: `get-id/${id}` });
  }

  getPaged(body: GetPagedBody<Partial<MembershipFilter>>) {
    return this.getPagedRequest<Membership[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<Membership[]>({ APIName: "getall" });
  }

  updateMembershipStatus(body: { membershipId: string; statusId: number; cancellationReason?: string }) {
    return this.put<boolean>({ APIName: "updatemembershipstatus", body, showAlert: true });
  }

  renewMembership(body: Record<string, unknown>) {
    return this.post<boolean>({ APIName: "renewmembership", body, showAlert: true });
  }

  checkAddingService() {
    if (localStorage.getItem(environment.tokenPropertyName)) {
      return this.get<number>({ APIName: "checkaddingservice" });
    }

    return of(1);
  }

  printMembershipCard(id: string) {
    return this.get<boolean>({ APIName: `print-membership-card/${id}`, showAlert: true });
  }

  addMembershipCardPhoto(body: Record<string, unknown>) {
    return this.put<boolean>({ APIName: "add-membership-card-photo", body, showAlert: true });
  }

  sendMemberMessage(body: Record<string, unknown>) {
    return this.post<string>({ APIName: "send-targeted-message", body, showAlert: true }).pipe(
      tap(() => this.toastrService.success(this.translation.instant("BE_VALIDATION.MessageSentSuccessfully"))),
    );
  }
}
